// WelcomeSection.js
import React from "react";
import side_image from "../../Assets/fancy2.gif"; // Your transparent firework GIF
import "./WelcomeSection.css";
import { Link } from "react-router-dom";

const WelcomeSection = ({ homeData }) => {
  return (
    <div className="nova-welcome">
      {/* Animated Background Firework Sparks (Canvas-like CSS) */}
      <div className="nova-ambient-sparks"></div>
      
      <div className="nova-container">
        {/* LEFT: Cinematic Visual Zone */}
        <div className="nova-visual-zone">
          <div className="nova-glow-core"></div>
          <div className="nova-visual-frame">
            <div className="nova-image-orb">
              <img 
                src={side_image} 
                alt="Fireworks Display" 
                className="nova-firework-gif"
              />
              {/* Dynamic Reflection Overlay */}
              <div className="nova-lens-flare"></div>
            </div>
            {/* Kinetic Rings with Variable Speeds */}
            <div className="nova-ring nova-ring-1"></div>
            <div className="nova-ring nova-ring-2"></div>
            <div className="nova-ring nova-ring-3"></div>
            
            {/* Micro Sparkles (Particle simulation) */}
            <div className="nova-sparkle nova-sparkle-1"></div>
            <div className="nova-sparkle nova-sparkle-2"></div>
            <div className="nova-sparkle nova-sparkle-3"></div>
            <div className="nova-sparkle nova-sparkle-4"></div>
            <div className="nova-sparkle nova-sparkle-5"></div>
          </div>
        </div>

        {/* RIGHT: Content with Kinetic Typography */}
        <div className="nova-content-zone">
          <div className="nova-badge-group">
            <span className="nova-badge-glow">✦ DIWALI SPECIAL {new Date().getFullYear()} ✦</span>
            <div className="nova-pulse-dot"></div>
          </div>
          
          <div className="nova-title-block">
            <p className="nova-intro-text">Illuminating Traditions Since 2012</p>
            <h1 className="nova-main-headline">
              <span className="nova-word-slide">Experience</span>
              <span className="nova-gradient-text"> Mycrackers</span>
            </h1>
            <div className="nova-fuse-line"></div>
          </div>

          {/* <div className="nova-location-data">
            <div className="nova-loc-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="#00E5FF"/>
              </svg>
            </div>
            <p>HQ: <strong>Sivakasi, India</strong> — Wholesale & Retail Hub</p>
          </div> */}

          {/* Rich Description with dynamic border glow */}
          <div className="nova-description-card">
            <div className="nova-card-shine"></div>
            <div className="nova-quote-mark">“</div>
            <div 
              className="nova-description-text" 
              dangerouslySetInnerHTML={{ __html: homeData?.value || "<p>Bringing the safest, brightest, and most spectacular fireworks to your celebrations. Trusted by thousands for premium quality and unmatched festive joy.</p>" }} 
            />
          </div>

          {/* Advanced Feature Pills with Neon Borders */}
          <div className="nova-feature-grid">
            <div className="nova-feature-pill">
              <div className="nova-pill-icon">🏆</div>
              <span>ISO Certified Quality</span>
              <div className="nova-pill-beam"></div>
            </div>
            <div className="nova-feature-pill">
              <div className="nova-pill-icon">🚚</div>
              <span>Express Pan-India</span>
              <div className="nova-pill-beam"></div>
            </div>
            <div className="nova-feature-pill">
              <div className="nova-pill-icon">💎</div>
              <span>Factory Direct Prices</span>
              <div className="nova-pill-beam"></div>
            </div>
          </div>

          {/* Interactive CTA */}
          <div className="nova-action-row">
            <Link to="/" className="nova-primary-btn">
              Explore Collection
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </Link>
            <div className="nova-trust-badge">
              <div className="nova-stars">★★★★★</div>
              <span>20k+ Happy Clients</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Gradient Scorch */}
      <div className="nova-ground-glow"></div>
    </div>
  );
};

export default WelcomeSection;